import { render, staticRenderFns } from "./RelatoriosSeguroConfig.vue?vue&type=template&id=92624e36&scoped=true"
import script from "./RelatoriosSeguroConfig.vue?vue&type=script&lang=js"
export * from "./RelatoriosSeguroConfig.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosSeguroConfig.vue?vue&type=style&index=0&id=92624e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92624e36",
  null
  
)

export default component.exports